export default __webpack_public_path__ + "static/media/ic_attachment_white.7f4f1dc7.svg";